import styled from 'styled-components';
import { theme } from '_constants/theme';
import { config } from '_config';
import { ROUTES } from '_constants/routes';
import Link from 'next/link';
import Button from '@mui/material/Button';
import * as React from 'react';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import axios from 'axios';

const { colors, devices, fontSizes, spaces } = theme;
const { apiUrl } = config;

const StyledMonitoringGraySection = styled.div`
  margin-top: 0px;
  padding-top: 100px;
  padding-bottom: 100px;
  background: #ecedf1;
  @media ${devices.tablet} {
    margin-top: 0px;
    padding-top: 0px;
    padding-bottom: 10px;
  }
`;
const StyledContainer = styled.div`
  max-width: 1400px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  flex-direction: row;
  gap: 50px;
  @media ${devices.tablet} {
    gap: 10px;
    flex-direction: column;
    padding-left: 16px;
    padding-right: 16px;
  }
`;
const StyledContainerColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
  flex: 1 1 0;
  p {
    color: #03589c;
    width: 100%;
    font-family: 'MontserratRegular';
    font-style: normal;
    font-size: ${fontSizes.regular}px;
    line-height: 18px;
    text-align: left;
  }
  img {
    max-width: 200px;
  }
`;
const StyledHeader = styled.div`
  color: #7b848d;
  font-family: 'MontserratBold';
  font-style: normal;
  font-size: 28px;
  width: 100%;
  padding-left: 175px;
  margin-bottom: -1rem;
  @media ${devices.tablet} {
    padding-left: 0px;
    text-align: center;
  }
`;
const StyledItemContainer = styled.div`
  display: flex;
  gap: 6px;
  flex-direction: column;
`;
const StyledItemContainer2 = styled.div`
  display: flex;
  gap: 6px;
  flex-direction: row;
`;
const StyledItemNumber = styled.div`
  color: #03589c;
  font-family: 'MontserratBold';
`;
const StyledItemTitle = styled.div`
  color: #f37217;
  font-family: 'MontserratBold';
`;
const StyledFooterItem = styled.div`
  display: flex;
  padding-left: 175px;
  color: #7b848d;
  width: 100%;
  font-family: 'MontserratBold';
  font-style: normal;
  font-size: 13px;
  line-height: 18px;
  text-align: left;
  align-items: center;
`;
const StyledItem = styled.div`
  display: flex;
  gap: 50px;
  img {
    max-width: 125px;
  }
  color: #7b848d;
  width: 100%;
  font-family: 'MontserratRegular';
  font-style: normal;
  font-size: 13px;
  line-height: 24px;
  text-align: left;
  align-items: center;
`;

const items = [
  {
    image: `${config.basePath}/monitoring3.png`,
    title: 'Why is trademark monitoring important?',
    text: "Trademark monitoring is crucial to protect your brand's identity and reputation. It prevents unauthorized usage, brand dilution, and counterfeiting.",
  },
  {
    image: `${config.basePath}/step-process-1.png`,
    title: 'How does Trademark Genius detect trademark infringements?',
    text: 'We use a combination of advanced technology and legal expertise to monitor trademarks and identify potential infringements.',
  },
  {
    image: `${config.basePath}/step-process-3.png`,
    title: 'Can small businesses benefit from trademark monitoring services?',
    text: 'Absolutely. We offer pricing packages that cater to businesses of all sizes, ensuring that even small businesses can protect their brands.',
  },
  {
    image: `${config.basePath}/step-process-2.png`,
    title:
      'What sets Trademark Genius apart from other trademark monitoring companies?',
    text: 'Our client-centric approach, expertise, and dedication to our clients make us stand out in the industry.',
  },
  {
    image: `${config.basePath}/faq-lockup.png`,
    title: "How can I get started with Trademark Genius's services?",
    text: "Getting started is easy. Simply reach out to us through our website or contact us via phone or email to discuss your brand's specific needs and objectives.",
  },
];
const MonitoringGraySection = () => {
  const router = useRouter();
  const [productName, setProductName] = useState(null);
  const [productPrice, setProductPrice] = useState(null);

  useEffect(() => {
    let salePage = window.location.href;
    let salePageURLArr = salePage.split('/');
    let salePageURL = (salePageURLArr[0] + '//' + salePageURLArr[2]).replace(
      /\/+$/,
      ''
    );
    let url = apiUrl + '/category/TRADEMARKS/products/prices';
    let fallbackUrl =
      `${salePageURL}/crm` + '/category/TRADEMARKS/products/prices';

    axios
      .get(url, {
        params: {
          onlyForSale: true,
          productCodes: 'TRADEMARK_Trademark_Monitoring',
          processingOptions: 'STANDARD',
        },
        headers: { 'Content-Type': 'application/json' },
      })
      .then((response) => {
        if (response.status === 200 && response.data.length > 0) {
          setProductName(response.data[0].code.customerName);
          setProductPrice(response.data[0].price);
        }
      })
      .catch((error) => {
        if (error.request) {
          axios
            .get(fallbackUrl, {
              params: {
                onlyForSale: true,
                productCodes: 'TRADEMARK_Trademark_Monitoring',
                processingOptions: 'STANDARD',
              },
              headers: { 'Content-Type': 'application/json' },
            })
            .then((response) => {
              if (response.status === 200 && response.data.length > 0) {
                setProductName(response.data[0].code.customerName);
                setProductPrice(response.data[0].price);
              }
            });
        }
      });
  }, []);
  return (
    <StyledMonitoringGraySection>
      <StyledContainer>
        <StyledContainerColumn>
          <div className="sides">
            <div className="side-box-wrapper">
              <div className="side-box-back-2"></div>
              <div className="side-box-back"></div>
              <div
                className="side-box"
                style={{ marginTop: '25px', marginBottom: '30px' }}
              >
                <div className="header-line"></div>
                <h4>{productName}</h4>
                <h5>
                  Protect against trademark infringement with our customized
                  monitoring system
                </h5>
                <div
                  className="orange-box"
                  style={{ cursor: 'pointer' }}
                  onClick={() => router.push(ROUTES.trademarkMonitoringFiling)}
                >
                  <div className="star"></div>
                  <div className="price-wrapper">
                    <div className="price">
                      {'$' + productPrice?.toFixed(2)}
                    </div>
                    <p style={{ textAlign: 'center' }}>quarterly</p>
                  </div>
                  <div className="star"></div>
                </div>
                <ul>
                  <li>
                    <span></span>
                    <p>
                      Professional customer focused support from specialists
                    </p>
                  </li>
                  <li>
                    <span></span>
                    <p>
                      Easy to read electronic report to stay informed on changes
                      within the market
                    </p>
                  </li>
                </ul>
                <Link href={ROUTES.trademarkMonitoringFiling}>
                  <Button>Start Now</Button>
                </Link>
              </div>
            </div>
          </div>
        </StyledContainerColumn>
        <StyledContainerColumn>
          <StyledHeader>Frequently Asked Questions</StyledHeader>
          {items.map((item, j) => (
            <StyledItem>
              <img src={item.image} alt="" layout="fill" />
              <StyledItemContainer2>
                <StyledItemNumber>{j + 1}.</StyledItemNumber>
                <StyledItemContainer>
                  <StyledItemTitle>{item.title}</StyledItemTitle>
                  {item.text}
                </StyledItemContainer>
              </StyledItemContainer2>
            </StyledItem>
          ))}
          <StyledFooterItem>
            Don't leave your brand's future to chance. Partner with Trademark
            Genius and secure the legacy of your brand. Get started today!
          </StyledFooterItem>
        </StyledContainerColumn>
      </StyledContainer>
    </StyledMonitoringGraySection>
  );
};

export default MonitoringGraySection;
